import { useCallback, useMemo } from "react";
import { useFileViewer } from "@/components/FileViewerDialog";
import { attachmentIdIndex, attachmentIdOf } from "@/utils/inlineImages";

export type InlineImageLoader = (
  attachmentId: string,
) => Promise<{ blob: Blob; filename?: string | null }>;

export function useInlineImagePreview(
  idByUrl: Map<string, string>,
  load: InlineImageLoader,
): (src: string, onClose?: () => void) => void {
  const viewFile = useFileViewer();
  const index = useMemo(() => attachmentIdIndex(idByUrl), [idByUrl]);
  return useCallback(
    (src: string, onClose?: () => void) => {
      const id = attachmentIdOf(index, src);
      if (!id) return;
      viewFile({
        title: "View image",
        load: () => load(id),
        errorMessage: "Could not open the image.",
        onClose,
      });
    },
    [index, load, viewFile],
  );
}
